import React from 'react';
import VerticalDashBorder from 'assets/svg/blue-dash-border-vertical.svg';
import HorizontalDashBorder from 'assets/svg/blue-dash-border-horizontal.svg';
import classes from './we-made-this.scss';
export const WeMadeThisComponent = ({
  text
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(text) && /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.titleBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "We made this."), /*#__PURE__*/React.createElement("img", {
    src: VerticalDashBorder,
    className: classes.verticalDashBorder
  }), /*#__PURE__*/React.createElement("img", {
    src: HorizontalDashBorder,
    className: classes.horizontalDashBorder
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textBlock,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};